module.exports = __webpack_public_path__ + "c2e3399346f7de89dbe44fdd3fec4dbd.png";